import {computed, Directive, inject, TemplateRef, ViewContainerRef} from '@angular/core';

import {CurrentUserService} from '../services/current-user.service';
import {PermissionId} from '../../api';

@Directive({
  selector: '[canAccessFinances]',
})
export class CanAccessFinances {
  private templateRef = inject(TemplateRef<unknown>);
  private viewContainer = inject(ViewContainerRef);
  private currentUserService = inject(CurrentUserService);
  private hasCanAccessFinancePermission = computed(() => this.currentUserService.currentUser()?.permissionIds.includes(PermissionId.CanAccessFinances) ?? false)

  ngOnInit() {
    if (this.hasCanAccessFinancePermission()) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
  }

}
